module.exports = __webpack_public_path__ + "img/mine_5_active.1daff78c.png";